import { render } from "./Departments.vue?vue&type=template&id=5977a6b7&scoped=true"
import script from "./Departments.vue?vue&type=script&lang=js"
export * from "./Departments.vue?vue&type=script&lang=js"

import "./Departments.vue?vue&type=style&index=0&id=5977a6b7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5977a6b7"

export default script